<template>
    <section class="section a-section a-section--fullheight">
        <div class="a-flex">
            {{ info }}
        </div>
    </section>
</template>

<script>
export default {
    computed: {
        info() {
            return this.$store.getters.info
        }
    }
}
</script>

<style lang="css" scoped>
</style>
